import { render, staticRenderFns } from "./AssignHistory.vue?vue&type=template&id=9fe800d8"
import script from "./AssignHistory.vue?vue&type=script&lang=js"
export * from "./AssignHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports